/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from 'react';
import { TypeAnimation } from "react-type-animation";
import { apiLaunchPad } from '../../../api/apiLaunchPad';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import Marquee from "react-fast-marquee";

const TokenCreate = () => {
    const [data, setData]: any = useState()
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();

    const GetDataDashboard = async () => {
        setLoading(true)
        try {
            let res = await apiLaunchPad.getDashboard();
            if (res.data.code === 200) {
                setData(res.data.data);
                setTimeout(() => {
                    setLoading(false)
                }, 1000);
            }
        } catch (error) {
            console.log("Error: ", error);
        }
    };

    useEffect(() => {
        GetDataDashboard()
    }, []);

    function goToX(): void {
        window.open('https://x.com/TinyBlock_io')
    }

    const images = [
        "/images/eth.png",
        "/images/bnb.png",
        "/images/avax.png",
        "/images/poly.png",
        "/images/arb.png",
        "/images/base.png", 
        "/images/mint.png",
        "/images/5ire.png",
        "/images/hela.png",
    ];

    return (
        <>
            <div className="main-page-launchpad">
                <div className="container-fluid">
                    <div className="wrap-token-sale">
                        <div className="wrap-colum">
                            <div className="left-colum">
                                <div className="content-create">
                                    <div className="title">
                                        <TypeAnimation
                                            style={{ whiteSpace: 'pre-line', display: 'block' }}
                                            sequence={[
                                                "T",
                                                1000,
                                                `Token Sale`,
                                                1000,
                                                "T",
                                                1000,
                                                `Token Sale`,
                                                1000,
                                            ]}
                                            wrapper="span"
                                            speed={30}
                                            repeat={Infinity}
                                        />
                                    </div>
                                    <div className="desc">
                                        Get early access to promising Web3 projects before they go public.
                                    </div>
                                    <div className="group-button">
                                        <div className="btn-item">
                                            <button className="main-button" onClick={() => navigate("/calendar-ido")}>
                                                View Calendar
                                            </button>
                                        </div>
                                        {/* <div className="btn-item">
                                            <button className="button-control">
                                                <img src="/images/air-btn.png" alt="" /> Get Notified
                                            </button>
                                        </div> */}
                                        <div className="btn-item">
                                            <button className="button-control" onClick={goToX}>
                                                <img src="/images/do-btn.png" alt="" /> Get Notified
                                            </button>
                                        </div>
                                    </div>
                                    <div className="text-chain-sp">
                                        Supported Blockchain
                                    </div>
                                    <div className="chain-support">
                                        <div className="marquee-container">
                                            <div className="marquee-wrapper">
                                                <Marquee
                                                    className="custom-marquee"
                                                    direction="left"
                                                    gradient
                                                    pauseOnHover
                                                    speed={50}
                                                    loop={0}
                                                    autoFill
                                                    gradientWidth={150}
                                                >
                                                    {images.map((item, index) => (
                                                        <div className="marquee-item">
                                                            <img
                                                                key={index}
                                                                src={images[index]}
                                                                alt={`Image ${index + 1}`}
                                                            />
                                                        </div>
                                                    ))}
                                                </Marquee>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="create-info-project">
                                        {isMobile ? (
                                            <>
                                                <div className="row">
                                                    <div className="depp-box">
                                                        <div className="txt">
                                                            ATH AVG ROI
                                                        </div>
                                                        <div className="number">
                                                            {loading ?
                                                                <>
                                                                    <Spin className="w-100" size="large" indicator={<LoadingOutlined style={{ fontSize: 30 }} spin />} />
                                                                </>
                                                                :
                                                                <>
                                                                    {data?.ath_avg_roi}
                                                                </>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="depp-box">
                                                        <div className="txt">
                                                            TOTAL RAISED
                                                        </div>
                                                        <div className="number">
                                                            {loading ?
                                                                <>
                                                                    <Spin className="w-100" size="large" indicator={<LoadingOutlined style={{ fontSize: 30 }} spin />} />
                                                                </>
                                                                :
                                                                <>
                                                                    {data?.total_raised}
                                                                </>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row row-cus">
                                                    <div className="depp-box">
                                                        <div className="txt">
                                                            PROJECTS LAUNCHED
                                                        </div>
                                                        <div className="number">
                                                            {loading ?
                                                                <>
                                                                    <Spin className="w-100" size="large" indicator={<LoadingOutlined style={{ fontSize: 30 }} spin />} />
                                                                </>
                                                                :
                                                                <>
                                                                    {data?.project_launched}
                                                                </>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>

                                            </>
                                        ) : (
                                            <>
                                                <div className="row">
                                                    <div className="depp-box">
                                                        <div className="txt">
                                                            ATH AVG ROI
                                                        </div>
                                                        <div className="number">
                                                            {loading ?
                                                                <>
                                                                    <Spin className="w-100" size="large" indicator={<LoadingOutlined style={{ fontSize: 30 }} spin />} />
                                                                </>
                                                                :
                                                                <>
                                                                    {data?.ath_avg_roi}
                                                                </>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row row-cus">
                                                    <div className="depp-box">
                                                        <div className="txt">
                                                            PROJECTS LAUNCHED
                                                        </div>
                                                        <div className="number">
                                                            {loading ?
                                                                <>
                                                                    <Spin className="w-100" size="large" indicator={<LoadingOutlined style={{ fontSize: 30 }} spin />} />
                                                                </>
                                                                :
                                                                <>
                                                                    {data?.project_launched}
                                                                </>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="depp-box">
                                                        <div className="txt">
                                                            TOTAL RAISED
                                                        </div>
                                                        <div className="number">
                                                            {loading ?
                                                                <>
                                                                    <Spin className="w-100" size="large" indicator={<LoadingOutlined style={{ fontSize: 30 }} spin />} />
                                                                </>
                                                                :
                                                                <>
                                                                    {data?.total_raised}
                                                                </>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )}

                                    </div>
                                </div>
                            </div>
                            <div className="right-colum">
                                <div className="box-img">
                                    <video
                                        playsInline
                                        webkit-playsinline
                                        className="no-background"
                                        autoPlay
                                        loop
                                        muted={true}
                                    >
                                        <source src="https://tinyblock.s3.ap-southeast-1.amazonaws.com/v22.mp4" type="video/mp4" />
                                    </video>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default TokenCreate